import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.1628693",
      d: "m22.797 6.763-2.035-.872 1.066-2.326-2.48.824a4.33 4.33 0 0 0-2.907-1.163 4.37 4.37 0 0 0-4.36 4.36v.97c-3.43.707-6.424-1.163-9.204-4.36Q2.15 8.07 4.33 10.008l-3.188-.485A4.41 4.41 0 0 0 5.26 13.4l-2.664.969c.969 1.937 2.732 2.238 5.086 2.422a11.16 11.16 0 0 1-6.54 1.938c12.363 5.493 19.62-2.578 19.62-9.69v-.804z"
    }, null, -1)
  ]))]))
}
export default { render: render }